import { useContext, useState, useEffect } from "react";
import { Stack, TextField, Typography } from "@mui/material";
import { AppContext } from "../App";

export function AdditionalInfo() {
  const { form, updateForm } = useContext(AppContext);
  const [error, setError] = useState(false);

  const MAX_CHARS = 200;

  // Initialize the value to empty string when component mounts
  useEffect(() => {
    if (form.additionalInfo === null) {
      updateForm({ additionalInfo: "" });
    }
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value.length <= MAX_CHARS) {
      updateForm({ additionalInfo: value });
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <Stack direction="column" spacing={2} alignItems="center">
      <Typography variant="h6">Any further details you'd like to share with your potential provider?</Typography>
      <Typography variant="subtitle1">Share additional information here ({MAX_CHARS} characters):</Typography>
      <TextField
        multiline
        rows={4}
        placeholder="Start typing..."
        value={form.additionalInfo || ""}
        fullWidth
        onChange={handleChange}
        error={error}
        helperText={
          form.additionalInfo &&
          `${form.additionalInfo.length}/${MAX_CHARS} characters${error ? " - Maximum length exceeded" : ""}`
        }
        slotProps={{
          htmlInput: {
            maxLength: MAX_CHARS,
          },
        }}
      />
    </Stack>
  );
}
